// extracted by mini-css-extract-plugin
export default {"container":"nJ-z","vocBtn":"oJ-z","disabled":"pJ-z"};